module.exports = __webpack_public_path__ + "800a1b0347f4c55ea06a7ba40b160d71.MP3";